import React, { useEffect } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import LoadingIndicator from "../LoadingIndicator/LoadingIndicator";
import PreEpGate from "@/modules/hub/features/PreEpWelcome/components/PreEpGate/PreEpGate";

/**
 * @see https://developer.auth0.com/resources/guides/spa/react/basic-authentication
 * @param component
 * @constructor
 */
export function AuthenticationGuard({
  component,
}: {
  component: React.ComponentType;
}) {
  const { isAuthenticated, isLoading, loginWithRedirect, error } = useAuth0();

  useEffect(() => {
    // If not loading, not authenticated, and we have an error (likely expired session)
    // or if we're not authenticated and not loading, trigger login
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: { returnTo: window.location.pathname },
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <LoadingIndicator />,
    returnTo: window.location.pathname,
  });

  // Show loading while Auth0 is checking authentication status
  if (isLoading) {
    return <LoadingIndicator />;
  }

  // If there's an authentication error, trigger login redirect
  if (error) {
    loginWithRedirect({
      appState: { returnTo: window.location.pathname },
    });
    return <LoadingIndicator />;
  }

  // A Pre-EP member's Hub+ is the full-screen Pre-EP pages (PreEpGate).
  return (
    <PreEpGate>
      <Component />
    </PreEpGate>
  );
}
